"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExposeEventObserver = void 0;
var inversify_1 = require("inversify");
var event_tracking_core_1 = require("@al/event-tracking-core");
var types_1 = require("../types");
var processor_1 = require("../utils/processor");
var event_1 = require("../utils/event");
var ExposeEventObserver = /** @class */ (function () {
    function ExposeEventObserver() {
    }
    ExposeEventObserver.prototype.update = function (data) {
        var items = this.transform(data.items);
        this.handle(items);
    };
    ExposeEventObserver.prototype.transform = function (items) {
        return items
            .map(function (item) {
            var data = item.data, rest = __rest(item, ["data"]);
            var saData = (0, processor_1.processDataset)(item.data);
            // 如果没有神策数据，直接返回 undefined，会被过滤掉
            if (!saData) {
                return;
            }
            var result = __assign(__assign({}, saData), { eventType: (0, event_1.resolveEventName)(saData || {}, types_1.EventType.Expose), duration: rest.duration });
            return result;
        })
            .filter(Boolean);
    };
    ExposeEventObserver.prototype.handle = function (data) {
        var _this = this;
        this.applicationExecutor.callWhenPrepared(function () {
            _this.sendToSaService.dispatch({
                list: data,
            });
        });
    };
    __decorate([
        (0, inversify_1.inject)(event_tracking_core_1.TYPES.IApplicationExecutor),
        __metadata("design:type", Object)
    ], ExposeEventObserver.prototype, "applicationExecutor", void 0);
    __decorate([
        (0, inversify_1.inject)(types_1.TYPES.ISendToSaService),
        __metadata("design:type", Object)
    ], ExposeEventObserver.prototype, "sendToSaService", void 0);
    ExposeEventObserver = __decorate([
        (0, inversify_1.injectable)()
    ], ExposeEventObserver);
    return ExposeEventObserver;
}());
exports.ExposeEventObserver = ExposeEventObserver;
